"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EditOutlined2 = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/EditOutlined.svg"));
var _Close = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/Close.svg"));
var _LoadingOutlined2 = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/LoadingOutlined.svg"));
var _CopyOutlined2 = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/CopyOutlined.svg"));
var _Check = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/Check.svg"));
var _button = _interopRequireDefault(require("../button"));
var _ellipsisTooltip = _interopRequireDefault(require("../ellipsis-tooltip"));
var _icon = _interopRequireDefault(require("../icon"));
var _space = _interopRequireDefault(require("../space"));
var _tooltip = _interopRequireDefault(require("../tooltip"));
var _ahooks = require("ahooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Text = props => {
  const {
    copyable,
    editable,
    ellipsis = true,
    link,
    children,
    alwayShowIcon,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-text");
  const ref = (0, _react.useRef)(null);
  const isHovering = alwayShowIcon || (0, _ahooks.useHover)(ref);
  const [textValue, setTextValue] = (0, _react.useState)(children !== null && children !== void 0 ? children : '');
  (0, _ahooks.useUpdateEffect)(() => {
    setTextValue(children);
  }, [children]);

  //Copy
  const [copyOk, setCopyOk] = (0, _react.useState)(false);
  const [targetDate, setTargetDate] = (0, _react.useState)();
  (0, _ahooks.useCountDown)({
    targetDate,
    onEnd: () => {
      setCopyOk(false);
    }
  });

  //Edit
  const [editing, onEditingChange] = (0, _ahooks.useControllableValue)(editable, {
    defaultValue: false,
    defaultValuePropName: 'defaultEditing',
    valuePropName: 'editing',
    trigger: 'onEditingChange'
  });
  const [editingValue, setEditingValue] = (0, _react.useState)('');
  const [editLoading, setEditLoading] = (0, _ahooks.useControllableValue)(editable, {
    defaultValue: false,
    defaultValuePropName: 'defaultEditLoading',
    valuePropName: 'editLoading',
    trigger: 'setEditLoading'
  });
  const [editHasError, setEditHasError] = (0, _react.useState)(false);

  //检查是否有错误，return true 为有错误
  const checkEditHasError = (0, _react.useCallback)(value => {
    if (editable !== null && editable !== void 0 && editable.rules) {
      try {
        var _editable$rules;
        editable === null || editable === void 0 || (_editable$rules = editable.rules) === null || _editable$rules === void 0 || _editable$rules.forEach(rule => {
          var _rule$validator, _rule$validator2;
          const validatorMsg = (_rule$validator = (_rule$validator2 = rule.validator) === null || _rule$validator2 === void 0 ? void 0 : _rule$validator2.call(rule, value)) !== null && _rule$validator !== void 0 ? _rule$validator : false;
          if (validatorMsg) {
            throw typeof validatorMsg === 'string' ? validatorMsg : (rule === null || rule === void 0 ? void 0 : rule.message) || true;
          } else if (rule.pattern && !rule.pattern.test(value)) {
            throw (rule === null || rule === void 0 ? void 0 : rule.message) || true;
          }
        });
      } catch (e) {
        e !== editHasError && setEditHasError(e);
        return true;
      }
    }
    editHasError !== false && setEditHasError(false);
    return false;
  }, [editable, editHasError]);
  const handleCheck = (0, _ahooks.useLockFn)(async value => {
    var _await$editable$onChe, _editable$onCheck;
    if (checkEditHasError(value)) {
      return;
    }
    setEditLoading(true);
    const flag = (_await$editable$onChe = await (editable === null || editable === void 0 || (_editable$onCheck = editable.onCheck) === null || _editable$onCheck === void 0 ? void 0 : _editable$onCheck.call(editable, value))) !== null && _await$editable$onChe !== void 0 ? _await$editable$onChe : true;
    if (!!flag) {
      setTextValue(value);
      onEditingChange(false);
    }
    setEditLoading(false);
  });
  const inputRef = (0, _react.useRef)(null);
  (0, _ahooks.useKeyPress)('enter', event => {
    handleCheck(editingValue);
  }, {
    target: inputRef
  });
  const TheText = (0, _react.useCallback)(() => {
    if (typeof textValue === 'string') {
      let text = /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: textValue
      });
      if (ellipsis) {
        text = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ellipsisTooltip.default, {
          tooltip: ellipsis == 'noTooltip' ? false : ellipsis,
          children: textValue
        });
      }
      if (link) {
        text = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
          to: link.to,
          children: text
        });
      }
      return text;
    }
    return textValue;
  }, [textValue, ellipsis]);
  if (children === undefined) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...restProps,
    className: (0, _classnames.default)(baseClassName, className),
    style: style,
    ref: ref,
    children: [editing ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default, {
      open: typeof editHasError === 'string' && !!editHasError,
      title: editHasError,
      getPopupContainer: target => document.querySelector('#popupContainer') || target.parentNode,
      ...(editable === null || editable === void 0 ? void 0 : editable.errorTooltipProps),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        className: (0, _classnames.default)('text-input', {
          error: !!editHasError
        }),
        style: {
          width: editable === null || editable === void 0 ? void 0 : editable.inputWidth
        },
        ref: inputRef,
        autoFocus: true,
        value: editingValue,
        onChange: e => {
          setEditingValue(e.target.value);
          checkEditHasError(e.target.value);
        },
        placeholder: editable === null || editable === void 0 ? void 0 : editable.placeholder,
        disabled: editLoading,
        onClick: e => {
          e.stopPropagation();
          return false;
        }
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(TheText, {}), copyable && (copyOk ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      type: "suggest/Check",
      className: "copyOkIcon"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      type: "CopyOutlined",
      className: (0, _classnames.default)('copyIcon', {
        isHovering
      }),
      onClick: e => {
        e.stopPropagation();
        const {
          text = textValue,
          format = 'text/plain',
          onCopy
        } = typeof copyable === 'boolean' ? {
          text: undefined,
          format: undefined,
          onCopy: undefined
        } : copyable;
        if (typeof text === 'string') {
          (0, _copyToClipboard.default)(text, {
            format
          });
          onCopy === null || onCopy === void 0 || onCopy(text);
          setCopyOk(true);
          setTargetDate(Date.now() + 3000);
        }
      }
    })), editable && typeof textValue === 'string' && (editLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      type: "LoadingOutlined",
      className: "editableLoadingIcon"
    }) : editing ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_space.default, {
      className: "editingActions",
      onClick: e => {
        e.stopPropagation();
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
        size: "s",
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
          type: "suggest/Check"
        }),
        onClick: e => {
          e.stopPropagation();
          handleCheck(editingValue);
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
        size: "s",
        type: "normal",
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
          type: "suggest/Close"
        }),
        onClick: e => {
          e.stopPropagation();
          onEditingChange(false);
        }
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      type: "EditOutlined",
      className: (0, _classnames.default)('editIcon', {
        isHovering
      }),
      onClick: e => {
        e.stopPropagation();
        setEditingValue(textValue);
        setEditHasError(false);
        onEditingChange(true);
      }
    }))]
  });
};
var _default = exports.default = Text;